define('drops/multiSelect/dropdownitem',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var DropDownItem = function (
            list,
            id,
            label,
            checked) {
        this.list = list;

        this.id = id;
        this.label = label;
        this.checked = !!checked;

        this.$checkbox = $('<input type = "checkbox" />')
            .prop('checked', this.checked)
            .on('change', this.onCheckboxToggled.bind(this));

        this.$element = $('<tr />')
            // width: 1px -> make sure the column does not use more space than really needed
            .append($('<td />').css('width', '1px').append(this.$checkbox));
    };

    DropDownItem.prototype.setReadOnly = function () {
        this.$checkbox.prop('disabled', true);
    };

    DropDownItem.prototype.addExtraColumns = function (values) {
        this.$element
            .append(_.map(values, this.createExtraColumn.bind(this)));
    };

    DropDownItem.prototype.createExtraColumn = function(value) {
        return $('<td />')
            .text(value)
            .on('click', this.onRowClicked.bind(this));
    };

    DropDownItem.prototype.onCheckboxToggled = function () {
        this.updated();
        this.triggerEvents();
    };

    DropDownItem.prototype.onRowClicked = function () {
        this.toggle();
        this.updated();
        this.triggerEvents();
    };

    DropDownItem.prototype.triggerEvents = function () {
        this.list.triggerEventIfEnabled('changed');

        if (this.checked)
            this.list.triggerEventIfEnabled('itemSelected', this.id);
        else
            this.list.triggerEventIfEnabled('itemDeselected', this.id);
    };

    DropDownItem.prototype.updated = function () {
        this.checked = this.$checkbox.is(":checked");

        this.list.updateSummary();
        this.list.updateRequiredIndicator();
    };

    DropDownItem.prototype.toggle = function () {
        if (this.checked)
            this.uncheck();
        else
            this.check();
    };

    DropDownItem.prototype.uncheck = function () {
        this.$checkbox.prop('checked', false);
        this.updated();
    };

    DropDownItem.prototype.check = function () {
        this.$checkbox.prop('checked', true);
        this.updated();
    };

    return DropDownItem;
});
